module.exports = __webpack_public_path__ + "static/media/jisung-2.jpeg";